import { useEffect, useState } from 'react';
import { OrderRejectReasonPage } from './seller/OrderRejectReasonPage';
import { DesktopOrderRejectReasonPage } from './desktop/DesktopOrderRejectReasonPage';

export function ResponsiveOrderRejectReasonPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  return isMobile ? <OrderRejectReasonPage /> : <DesktopOrderRejectReasonPage />;
}